export enum TimesheetsScreenNames {
  MAIN = 'timesheets',
  TIMESHEETS = 'timesheets_list',
  TIMESHEET = 'timesheet',
  EDIT_TIMESHEET = 'edit_timesheet',
}
